import {
  DeserializedRecord,
  deserializeItem,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "../../Helpers";
import {deserializeMedicalBilling, MedicalBilling} from "../../MedicalBilling";
import {deserializePatientTreatment, PatientTreatment} from "../../patient/Treatment";

type TaskRelationResourceSubjectType = MedicalBilling;
type TaskRelationResourceLinkedSubjectType = PatientTreatment;

interface TaskRelationResource extends DeserializedRecord {
  subjectType: string;
  subjectId: string;
  subject: TaskRelationResourceSubjectType;
  linkedSubject: TaskRelationResourceLinkedSubjectType;
}

interface TaskRelationResourceData extends JSONAPIRecord {
  relationships: {
    subject: JSONAPISingleRelationship;
    linked_subject: JSONAPISingleRelationship;
  }
}

const deserializeByResourceType = (resourceType: string) => {
  switch (resourceType) {
    case "medical_billing":
      return deserializeMedicalBilling;
    default:
      return deserializeItem;
  }
};

const deserializeByLinkedResourceType = (resourceType: string) => {
  switch (resourceType) {
    case "patient_treatment":
      return deserializePatientTreatment;
    default:
      return deserializeItem;
  }
};

const deserializeTaskRelationResource: Deserializer<TaskRelationResource, TaskRelationResourceData> = (data, included) => {
  const attributes = deserializeItem<TaskRelationResource>(data);

  const subject = deserializeSingleRelationship<TaskRelationResourceSubjectType>(
    data.relationships.subject,
    included,
    deserializeByResourceType(data.relationships.subject?.data?.type));

  const linkedSubject = deserializeSingleRelationship<TaskRelationResourceLinkedSubjectType>(
    data.relationships.linked_subject,
    included,
    deserializeByLinkedResourceType(data.relationships.linked_subject?.data?.type));

  return {
    ...attributes,
    subject,
    linkedSubject
  };
};

export {
  deserializeTaskRelationResource, TaskRelationResource
};
